/** Пути роутера. Строки только здесь — в шаблонах ссылаемся на ROUTE.*. */
export const ROUTE = {
  start: '/start',
  auth: '/auth',
  home: '/home',
  menu: '/menu',
  product: '/menu/:id',
  cart: '/cart',
  checkout: '/checkout',
  orders: '/orders',
  order: '/orders/:id',
  profile: '/profile',
  favorites: '/profile/favorites',
  addresses: '/profile/addresses',
  cards: '/profile/cards',
  promo: '/profile/promo',
  notifications: '/profile/notifications',
  settings: '/profile/settings',
  chat: '/profile/chat',
  chatRoom: '/profile/chat/:id',
  uiKit: '/ui-kit',
} as const

export type Route = (typeof ROUTE)[keyof typeof ROUTE]
